import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Stack } from "@mui/material";
import "./Header.scss";
import puravankarLogo from "../../assets/icons/purva-logo-white.png";
import ProvidentLogo from "../../assets/images/Provident Reverse logo.png";
import PurvaLandLogo from "../../assets/images/PurvaLand Master Logo reverse.png";

import { useDispatch, useSelector } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { COMPARE_VALUE } from "../../config/constant";
import { BRAND_ASSET_SPECS, resolveBrandCdnUrl } from "../../config/brandAssetSpecs";
import { setShowMobileStepper } from "../../pages/new-booking-form/new-booking-form.slice";

// Header can work in two modes:
// - Controlled (Voucher form): pass isMenuOpen and onToggleMenu
// - Uncontrolled (Customer form): falls back to customerForm slice
const Header = ({ logo, isMenuOpen, onToggleMenu }) => {
  const dispatch = useDispatch();

  const { enquiryDetails, showMobileStepper, brandLogo, partnerHeaderImage } =
    useSelector((state) => state.newBookingForm);

  const effectiveIsMenuOpen =
    typeof isMenuOpen === "boolean" ? isMenuOpen : showMobileStepper;
  const brandSpec = BRAND_ASSET_SPECS.headerBrandLogo;
  const partnerSpec = BRAND_ASSET_SPECS.headerPartnerLogo;

  const handleMenuToggle = () => {
    if (typeof onToggleMenu === "function") {
      onToggleMenu(); // Voucher form controls its own state
    } else {
      // Customer form fallback
      dispatch(setShowMobileStepper(!showMobileStepper));
    }
  };
  const getBrandImageSrc = () => {
    const fromCdn = resolveBrandCdnUrl(brandLogo || "");
    if (fromCdn) return fromCdn;
    if (
      (enquiryDetails?.data &&
        enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara) ||
      logo === COMPARE_VALUE?.Puravankara
    ) {
      return puravankarLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return ProvidentLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return PurvaLandLogo;
    }
  };

  const jvPartnerLogoFilename =
    partnerHeaderImage || "";
  const jvPartnerLogoUrl = resolveBrandCdnUrl(jvPartnerLogoFilename);
  const showJvPartnerLogo = Boolean(jvPartnerLogoUrl);

  return (
    <>
      <Stack
        sx={{
          backgroundColor: "#1A407D",
          position: "fixed",
          top: "0px",
          left: "0px",
          height: {
            xs: "60px",
            sm: "60px",
            md: "88px",
          },
          width: "100%",
          zIndex: 99,
          color: "#ffff",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          spacing={0}
          className="headerPLeftRight"
          sx={{
            p: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: {
              xs: "16px",
              sm: "16px",
              md: "7%",
            },
            paddingRight: {
              xs: "16px",
              sm: "16px",
              md: "7%",
            },
          }}
        >
          <Grid item xs="auto" sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                width: brandSpec.displaySlotPx.maxWidth,
                height: brandSpec.displaySlotPx.maxHeight,
                display: "block",
                overflow: "hidden",
              }}
            >
              {getBrandImageSrc() ? (
                <img
                  src={getBrandImageSrc()}
                  alt="Logo"
                  style={{
                    maxWidth: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : null}
            </Box>
          </Grid>

          <Grid item xs="auto" sx={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
            <Stack direction="row" alignItems="center" spacing={{ xs: 1, sm: 1.5, md: 2 }}>
              {showJvPartnerLogo && (
                <Box
                  component="img"
                  src={jvPartnerLogoUrl}
                  alt="Partner logo"
                  sx={{
                    maxHeight: partnerSpec.displaySlotPx.maxHeight,
                    objectFit: partnerSpec.objectFit,
                    flexShrink: 0,
                  }}
                />
              )}
              <button className="resetButton MenuIconMobile" onClick={handleMenuToggle}>
                {effectiveIsMenuOpen ? <CloseIcon /> : <MenuIcon />}
              </button>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
      <div className="extraHeight"></div>
    </>
  );
};



Header.propTypes = {
  isMenuOpen: PropTypes.bool,
  logo: PropTypes.any,
  onToggleMenu: PropTypes.func,
};

export default Header;
